import React, { useState, useEffect } from "react";
import './styles.css';
import { global } from "../../../../global";
import imgBanner from '../../../../assets/pictures/bannerHome.png'

function PrimarySection() {

const {wellezyLogo} = global.img.logos

  return (
    <section className='homePrimarySection'>
      <img src={imgBanner} alt="" className="img-banner-home"/>
      <div className="cap-black">
        <img src={wellezyLogo} alt="" />
      </div>
     
    </section>
  )
}

export default PrimarySection;
